import React, {createContext, useContext, useEffect, useState} from "react";
import {COOKIE_KEY, LANG_KEY} from "../constants";
import {ILang} from "../types";
import {Cookies} from "react-cookie";
import {useTranslation} from "react-i18next";
import {getFromUrl} from "../utils/getFromUrl";

const cookies = new Cookies();

const initialState: ILang = {
  lang: LANG_KEY.RU,
  handleChangeLang: (value: string) => {
  }
}

const LangContext = createContext<ILang>(initialState);

export const LangProvider = ({children}: any) => {
  const [lang, setLang] = useState<any>(cookies.get(COOKIE_KEY.LANG) || LANG_KEY.RU)
  const {i18n} = useTranslation();

  const langFromUrl = getFromUrl(COOKIE_KEY.LANG_OLD) || getFromUrl(COOKIE_KEY.LANG);

  const langObj:any = {
    "kz-KZ":LANG_KEY.KZ,
    [LANG_KEY.KZ]: LANG_KEY.KZ,
    [LANG_KEY.RU]: LANG_KEY.RU
  }

  useEffect(() => {
    const previousLangFromUrl = sessionStorage.getItem('langFromUrl');

    if (langFromUrl && (langFromUrl !== previousLangFromUrl)) {
      const newLang = langObj[langFromUrl];
      if (newLang && newLang !== lang) {
        sessionStorage.setItem('langFromUrl', langFromUrl);
        cookies.set(COOKIE_KEY.LANG, newLang, { path: '/' });
        setLang(newLang);
        i18n.changeLanguage(newLang);
        // Reload the page to apply the language change
        window.location.reload();
      } else {
        i18n.changeLanguage(lang);
      }
    } else {
      i18n.changeLanguage(lang);
    }

    const langHandler = (options: any) => {
      if (options.name === COOKIE_KEY.LANG && options.value) {
        setLang(options.value);
        i18n.changeLanguage(options.value);
        window.location.reload();
      }
    };

    cookies.addChangeListener(langHandler);

    return () => {
      cookies.removeChangeListener(langHandler);
    };
  }, [langFromUrl, lang, i18n]);

  const handleChangeLang = (value: string | null) => {
    const newLang = lang === LANG_KEY.RU ? LANG_KEY.KZ : LANG_KEY.RU;
    cookies.set(COOKIE_KEY.LANG, newLang, { path: '/' });
    setLang(newLang);
  };

  return (
    <LangContext.Provider value={{lang, handleChangeLang}}>
      {children}
    </LangContext.Provider>
  )
}

export const useLang = () => useContext(LangContext)